import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import { auth } from "../../Authentication/firebase/firebase";
import API_Root from "../../Constants/API_Root";
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import { authFetch } from "../../Authentication/authService";

const SIDEBAR_WIDTH = 250;

function MyProduct() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userEmail, setUserEmail] = useState("");

  // NEW: store processed products here
  const [productsData, setProductsData] = useState([]);

  const history = useHistory();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);
        fetchProfileInformation(user.email);
      } else {
        setUserEmail("");
      }
    });

    return () => unsubscribe();
  }, []);

  // 👉 PROCESS API RESPONSE HERE
  const fetchProfileInformation = (username) => {
    authFetch(API_Root + "subscription/user-subscription-details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username }),
    })
      .then((response) => response.json())
      .then((data) => {
        prepareProducts(data);
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleLogout = () => {
    doSignOut()
      .then(() => {
        localStorage.removeItem("isLoggedIn");
        history.push("/");
      })
      .catch(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Logout failed",
          })
        );
      });
  };

  // 👉 MAP API RESPONSE → UI PRODUCT CARDS
  const prepareProducts = (apiData) => {
    const temp = [];

    // ========== 1️⃣ DiscloseAI ==========
    if (apiData.DiscloseAI?.subscription) {
      const sub = apiData.DiscloseAI.subscription;

      temp.push({
        id: apiData.DiscloseAI.product_info.product_id,
        name: apiData.DiscloseAI.product_info.product_name,
        status:
          sub.status === "active"
            ? "Active"
            : sub.status === "trial"
            ? "Trial"
            : "Expired",
        statusColor:
          sub.status === "active"
            ? "success"
            : sub.status === "trial"
            ? "warning"
            : "danger",
        description: apiData.DiscloseAI.product_info.product_caption,
        plan: sub.plan_type + " Plan",
        nextPayment: new Date(sub.plan_end_date).toDateString(),
        buttonText: "Open Product",
        badge: sub.plan_type + " Plan",
        icon: apiData.DiscloseAI.product_info.product_icon,
        buttonName: "DiscloseAi",
      });
    }

    // ========== 2️⃣ myESRA ==========
    if (apiData["myESRA"]?.subscription) {
      const sub = apiData["myESRA"]?.subscription;
      temp.push({
        id: apiData["myESRA"]?.product_info?.product_id,
        name: apiData["myESRA"]?.product_info?.product_name,
        status:
          sub.status === "active"
            ? "Active"
            : sub.status === "trial"
            ? "Trial"
            : "Expired",
        statusColor:
          sub.status === "active"
            ? "success"
            : sub.status === "trial"
            ? "warning"
            : "danger",
        description: apiData["myESRA"]?.product_info?.product_caption,
        plan: sub.plan_type + " Plan",
        nextPayment: new Date(sub.plan_end_date).toDateString(),
        buttonText: "Open Product",
        badge: sub.plan_type + " Plan",
        icon: apiData["myESRA"].product_info?.product_icon,
        buttonName: "myESRA",
      });
    }

    // ========== 3️⃣ privatESRA ==========
    if (apiData["privatESRA"]?.subscription) {
      const sub = apiData["privatESRA"]?.subscription;
      temp.push({
        id: apiData["privatESRA"]?.product_info?.product_id,
        name: apiData["privatESRA"]?.product_info?.product_name,
        status:
          sub.status === "active"
            ? "Active"
            : sub.status === "trial"
            ? "Trial"
            : "Expired",
        statusColor:
          sub.status === "active"
            ? "success"
            : sub.status === "trial"
            ? "warning"
            : "danger",
        description: apiData["privatESRA"]?.product_info?.product_caption,
        plan: sub.plan_type + " Plan",
        nextPayment: new Date(sub.plan_end_date).toDateString(),
        buttonText: "Open Product",
        badge: sub.plan_type + " Plan",
        icon: apiData["privatESRA"].product_info?.product_icon,
        buttonName: "privatESRA",
      });
    }

    // ========== 3️⃣ Ventures ==========
    if (apiData["workspace"]?.subscription) {
      const sub = apiData["workspace"]?.subscription;
      temp.push({
        id: apiData["workspace"]?.product_info?.product_id,
        name: apiData["workspace"]?.product_info?.product_name,
        status:
          sub.status === "active"
            ? "Active"
            : sub.status === "trial"
            ? "Trial"
            : "Expired",
        statusColor:
          sub.status === "active"
            ? "success"
            : sub.status === "trial"
            ? "warning"
            : "danger",
        description: apiData["workspace"]?.product_info?.product_caption,
        plan: sub.plan_type + " Plan",
        nextPayment: new Date(sub.plan_end_date).toDateString(),
        buttonText: "Open Product",
        badge: sub.plan_type + " Plan",
        icon: apiData["workspace"].product_info?.product_icon,
        buttonName: "workspace",
      });
    }

    // ========== 4️⃣ reviewESRA – you can add when API gives it ==========
    // If later API gives this product, add similar mapping logic here.

    setProductsData(temp);
  };

  useEffect(() => {
    const resize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const containerStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const contentStyle = {
    // marginLeft: isDesktop ? SIDEBAR_WIDTH : 0,
    width: "100%",
    transition: "margin-left 0.3s ease",
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });

  const AccountPage = () => history.push("/profile");
  const ActivityPage = () => history.push("/activity");
  const ShopPage = () => history.push("/shops");
  const SuportPage = () => history.push("/support");
  const TrainingPage = () => {
    history.push("/training");
  };
  const handleRouting = (product) => {
    if (product === "DiscloseAi") {
      window.open(
        "https://www.essolutions.ai/discloseai",
        "_blank",
        "noopener,noreferrer"
      );
    }
    if (product === "privatESRA") {
      history.push("/privatesra");
    }
    if (product === "myESRA") {
      history.push("/chat");
    }
    if(product === "workspace"){
      history.push("/ventureLogin")
    }
  };

  return (
    <div className="container-fluid p-0">
      <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

      <div className="d-flex">
        {/* Sidebar */}
        <div style={sidebarStyle}>
          <h5 className="fw-bold mb-4 d-flex justify-content-between align-items-center">
            E&S Solutions
            {!isDesktop && (
              <i
                className="bi bi-x-lg d-md-none"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(false)}
              ></i>
            )}
          </h5>

          <div style={activeNavItemStyle}>My Products</div>

          <div
            style={getHoverStyle("Shop / Marketplace")}
            onMouseEnter={() => setHoveredItem("Shop / Marketplace")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ShopPage}
          >
            Shop / Marketplace
          </div>

          <div
            style={getHoverStyle("E&S Solutions Training Centre")}
            onMouseEnter={() => setHoveredItem("E&S Solutions Training Centre")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={TrainingPage}
          >
            E&S Solutions Training Centre
          </div>

          <div
            style={getHoverStyle("Support & Help")}
            onMouseEnter={() => setHoveredItem("Support & Help")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={SuportPage}
          >
            Support & Help
          </div>

          <div
            style={getHoverStyle("Account Settings")}
            onMouseEnter={() => setHoveredItem("Account Settings")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={AccountPage}
          >
            Account Settings
          </div>
          {/* 
          <div style={getHoverStyle("Community & Resources")} onMouseEnter={() => setHoveredItem("Community & Resources")} onMouseLeave={() => setHoveredItem(null)}>
            Community & Resources
          </div> */}

          <div
            onClick={ActivityPage}
            style={getHoverStyle("Activity Log")}
            onMouseEnter={() => setHoveredItem("Activity Log")}
            onMouseLeave={() => setHoveredItem(null)}
          >
            Activity Log
          </div>
        </div>

        {/* Main Content */}
        <div style={contentStyle}>
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            {!isDesktop && (
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              ></i>
            )}
            <h4 className="fw-bold m-0">My Products</h4>
            <div>
              <button
                className="me-2"
                onClick={handleLogout}
                style={{
                  border: "1px solid black",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  padding: "5px",
                  transition: "all 0.3s ease",
                  fontSize: "small",
                }}
              >
                Logout
              </button>
              <i className="bi bi-bell me-3"></i>
              <img
                src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
                alt="Profile"
                width={"20px"}
                className="rounded-circle"
              />
            </div>
          </div>

          {/* Products */}
          <div
            className="p-4"
            style={{ maxWidth: "100%", overflowX: "hidden" }}
          >
            <div style={containerStyle}>
              <div className="row">
                <div className="col-md-12 border-end">
                  <h6 className="fw-bold mb-3">My Products</h6>
                  <p className="text-muted small mb-4">
                    Access and manage your E&S Solutions tools.
                  </p>
                </div>

                <div className="row">
                  {productsData.map((product, index) => (
                    <div key={index} className="col-md-6 col-lg-4 mb-4 d-flex">
                      <div
                        className="card flex-fill"
                        style={{
                          borderRadius: "12px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          border: "1px solid #eaeaea",
                        }}
                      >
                        <div className="card-body d-flex flex-column">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                              <img
                                src={product.icon}
                                className="rounded-circle me-2"
                                width="20px"
                                alt="product"
                              />
                              <h6 className="mb-0 fw-bold">{product.name}</h6>
                            </div>
                            <span
                              className={`badge bg-${product.statusColor} text-white`}
                              style={{
                                fontSize: "0.75rem",
                                borderRadius: "12px",
                                padding: "4px 10px",
                              }}
                            >
                              {product.status}
                            </span>
                          </div>

                          <p
                            className="text-muted mb-2"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {product.description}
                          </p>

                          <p className="text-muted small mb-3">
                            15 Reports submitted this month
                          </p>

                          <div
                            className="d-flex justify-content-between align-items-center p-2 mb-3"
                            style={{
                              backgroundColor: "#f9f9f9",
                              borderRadius: "8px",
                            }}
                          >
                            <span
                              className="badge bg-success text-white"
                              style={{
                                fontSize: "0.75rem",
                                borderRadius: "8px",
                              }}
                            >
                              {product.plan}
                            </span>
                            <div>
                              <small className="text-muted d-block">
                                Next Payment
                              </small>
                              <strong>{product.nextPayment}</strong>
                            </div>
                            <div className="d-flex align-items-center">
                              <img
                                src={product.icon}
                                className="rounded-circle me-2"
                                width="20px"
                                alt="user"
                              />
                              <button className="btn btn-sm btn-outline-secondary">
                                <i className="bi bi-plus"></i>
                              </button>
                            </div>
                          </div>

                          <div className="d-flex justify-content-between mb-3 gap-2">
                            <button className="btn btn-outline-dark btn-sm">
                              Manage Subscription
                            </button>
                            <button className="btn btn-outline-dark btn-sm">
                              View Invoices
                            </button>
                          </div>

                          <button
                            className="btn w-100 text-white mt-auto"
                            style={{
                              backgroundColor: "#195b41",
                              borderRadius: "8px",
                              fontWeight: "500",
                            }}
                            onClick={() => handleRouting(product.buttonName)}
                          >
                            {product.buttonText}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-flex justify-content-end mt-4">
                <button className="btn btn-dark" onClick={ShopPage}>
                  Visit Shop to explore more products
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyProduct;
